import { AnimatePresence } from 'framer-motion'
import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectChatInitialized, setChatInitialized } from 'store/messages'
import { WidgetLauncher } from 'components/WidgetLauncher'
import { getUserToken } from 'utils/query-params'
import { WidgetContent } from 'WidgetContent'
import { WidgetHelpMessage } from 'components/WidgetHelpMessage'
import { selectIsOpened } from 'store/widget'
import { getMyChats } from 'api/chats'
import 'react-toastify/dist/ReactToastify.css'
import { useGetBotMode } from 'hooks/useGetBotMode'
import { settingsActions } from 'store/settings'

export const useConfigureChat = () => {
  const dispatch = useDispatch()
  const chatInitialized = useSelector(selectChatInitialized)

  const initializeChat = useCallback(async () => {
    const userToken = getUserToken()
    if (chatInitialized) return
    if (userToken) {
      await getMyChats({})
      dispatch(setChatInitialized(true))
      return
    }
  }, [chatInitialized])

  return useMemo(() => initializeChat, [initializeChat])
}

type WidgetLayoutProps = {
  areaId?: string
  filterChatsByAreaId?: boolean
  visible?: boolean
}

export const WidgetLayout = ({ areaId, filterChatsByAreaId, visible = true }: WidgetLayoutProps) => {
  const isOpened = useSelector(selectIsOpened)
  const { isAppMode } = useGetBotMode()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(settingsActions.setAreaId(areaId))

    if (filterChatsByAreaId) {
      getMyChats({ areaId }).catch(console.error)
    }
  }, [areaId, dispatch])

  if (!visible) {
    return null
  }

  return (
    <AnimatePresence>
      <WidgetHelpMessage key={'help'} />
      {(isOpened || isAppMode) && <WidgetContent key={'content'} />}
      {!isAppMode && <WidgetLauncher key={'launcher'} />}
    </AnimatePresence>
  )
}
